// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactDomElement from "./ReactDomElement.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function use(forwardedRef, param) {
  let match = React.useState(() => ({
    width: 0,
    height: 0
  }));
  let setDimensions = match[1];
  let ref = forwardedRef !== undefined ? forwardedRef : React.useRef(null);
  let resizeTimeoutIdRef = React.useRef(null);
  let onResizeChanged = React.useCallback(maybeDomElement => (param => {
    if (maybeDomElement !== undefined) {
      let domElement = Primitive_option.valFromOption(maybeDomElement);
      let dimensions_width = Math.floor(domElement.offsetWidth);
      let dimensions_height = Math.floor(domElement.offsetHeight);
      let dimensions = {
        width: dimensions_width,
        height: dimensions_height
      };
      let timeoutId = setTimeout(() => setDimensions(param => dimensions), 75);
      resizeTimeoutIdRef.current = timeoutId;
    }
    let id = resizeTimeoutIdRef.current;
    if (!(id == null)) {
      clearTimeout(id);
      return;
    }
  }), [ref.current]);
  React.useEffect(() => {
    let domElement = ReactDomElement.fromRef(ref);
    if (domElement !== undefined) {
      let domElement$1 = Primitive_option.valFromOption(domElement);
      window.addEventListener("resize", onResizeChanged(Primitive_option.some(domElement$1)));
      setDimensions(param => ({
        width: Math.floor(domElement$1.offsetWidth),
        height: Math.floor(domElement$1.offsetHeight)
      }));
    }
    return () => {
      window.removeEventListener("resize", onResizeChanged(undefined));
    };
  }, [ref.current]);
  return [
    ref,
    match[0]
  ];
}

export {
  use,
}
/* react Not a pure module */
